import { AuthGuard } from '../shared/guards/auth.guard';
import { Routes } from '@angular/router';

export const userRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./user/user.component').then((c) => c.UserComponent),
    children: [
      { path: '', redirectTo: 'account-settings', pathMatch: 'full' },
      {
        path: 'my-searches',
        loadComponent: () =>
          import('./user/my-searches/my-searches.component').then(
            (c) => c.MySearchesComponent
          ),
      },
      {
        path: 'subscription',
        loadComponent: () =>
          import('./user/subscriptions-menu/subscriptions-menu.component').then(
            (c) => c.SubscriptionsMenuComponent
          ),
      },
      {
        path: 'account-settings',
        loadComponent: () =>
          import(
            './user/account-settings-form/account-settings-form.component'
          ).then((c) => c.AccountSettingsFormComponent),
      },
    ],
    canActivate: [AuthGuard],
  },
];
